import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import {NavigationContext} from '../../../enhancers/router-enhancer';
import {SIGN_IN_PATH} from '../../../../bundles/feed/constants/utils';
import glamorous from 'glamorous';
import SimpleButton from '../../../../shared/library/buttons/base/simple';
import {FOCUS_BLUE} from '../../../../shared/style/colors';
import {BASE_TEXT} from '../../../../shared/style/typography';
import SignUpCta from '../../../../shared/library/icons/signup-cta.svg';
import Heading from '../../../../shared/library/typography/heading';
import {PHONE} from '../../../../shared/style/breakpoints';
import {withSendAnalyticsEvent} from '../../../enhancers/analytics-enhancer';
import {SIGNUP_PANEL_CLICK} from '../../../constants/analytics';
// import DwellTracker from '../../../utils/dwell-tracker';

const Container = glamorous.div({
  ...BASE_TEXT,
  maxWidth: 1170,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  cursor: 'pointer',
  [PHONE]: {
    padding: 10,
    flexWrap: 'wrap',
    width: '100vw',
    margin: 0,
    justifyContent: 'center',
    border: 0
  }
});

const ContainerInner = glamorous.div({
  display: 'flex',
  [PHONE]: {
    width: 'auto'
  }
});

const CallOut = glamorous.span({
  color: FOCUS_BLUE,
  display: 'block',
  fontSize: 12,
  fontWeight: 'normal'
});

const StyledSignUpCta = glamorous(SignUpCta)({
  marginRight: 40,
  width: 40,
  height: 40,
  flexShrink: 0
});

const StyledSimpleButton = glamorous(SimpleButton)({
  height: 34,
  width: 270,
  fontSize: 13,
  [PHONE]: {
    marginTop: 10
  }
});

const StyledHeading = glamorous(Heading)({
  fontSize: 15,
  lineHeight: 32 / 22
});

const SignUpPanel = ({heading, callout, cta, section, sendAnalyticsEvent, analyticsPayload}) => {
  const signupPanelRef = useRef(null);

  // useEffect(() => {
  //   if (signupPanelRef.current) {
  //     new DwellTracker(signupPanelRef.current, time =>
  //       sendAnalyticsEvent(SIGNUP_PANEL_DWELL, {
  //         ...analyticsPayload,
  //         time,
  //         section
  //       })
  //     );
  //     new DwellTracker(
  //       signupPanelRef.current,
  //       () => {
  //         sendAnalyticsEvent(SIGNUP_PANEL_SHOWN, {...analyticsPayload, section});
  //       },
  //       1
  //     );
  //   }
  // }, []);

  const onPanelClick = navigate => {
    navigate(SIGN_IN_PATH);
    sendAnalyticsEvent(SIGNUP_PANEL_CLICK, {...analyticsPayload, section});
  };

  return (
    <NavigationContext.Consumer>
      {navigate => (
        <Container onClick={() => onPanelClick(navigate)} innerRef={signupPanelRef}>
          <ContainerInner>
            <StyledSignUpCta />
            <StyledHeading>
              {heading}
              <CallOut>{callout}</CallOut>
            </StyledHeading>
          </ContainerInner>
          <StyledSimpleButton data-testid="signupFullAccessButton" width={270}>
            {cta}
          </StyledSimpleButton>
        </Container>
      )}
    </NavigationContext.Consumer>
  );
};

SignUpPanel.propTypes = {
  heading: PropTypes.string.isRequired,
  callout: PropTypes.string.isRequired,
  cta: PropTypes.string.isRequired,
  analyticsPayload: PropTypes.object,
  section: PropTypes.string,
  sendAnalyticsEvent: PropTypes.func
};

export default withSendAnalyticsEvent(SignUpPanel);
